import React from "react";
import Pinned from "../../../assets/icons/pinned.svg";
import Pinable from "../../../assets/icons/pinable.svg";
import "./Pin.scss";
const pin = (props) => {
  const pinnedClass = props.hoverId === props.folderId ? "show" : "hide";
  return props.checkPin ? (
    <div className="custom-pinned ml-2">
      <img
        className="pb-1"
        src={Pinned}
        alt="Pinned"
        width="14"
        heigh="14"
        onClick={props.pinHandler}
      />
    </div>
  ) : (
    <div className={[pinnedClass, "custom-pinable ml-2"].join(" ")}>
      <img
        className="pb-1"
        src={Pinable}
        alt="Pinable"
        width="14"
        heigh="14"
        onClick={props.pinHandler}
      />
    </div>
  );
};

export default pin;
